import { queryClient } from "@/configs/react-query";
import { useAuthStore } from "@/store/use-auth-store";

/**
 * Sessiyani butunlay yopadi.
 *
 * Faqat `logout()` yetmaydi: har bir ro'yxat `keepPreviousData` bilan
 * ishlaydi, ya'ni kesh chiqishdan keyin ham joyida qoladi. Admin hisobidan
 * chiqib, o'sha tabda student bo'lib kirilganda oldingi hisobning
 * foydalanuvchilari, to'lovlari va murojaatlari ekranga chiqib qolardi.
 */
export const hardLogout = () => {
  useAuthStore.getState().logout();
  queryClient.clear();
};
